import { twMerge } from 'tailwind-merge';
import { AnswerContent } from '@/components/question/view/primitives/shared/AnswerContent';
import {
  FillInTheBlankCorrectionSegment,
  FillInTheBlankCorrectionStatus,
} from '@/components/question/view/typologies/fill-in-the-blank/useFillInTheBlankCorrection';

type FillInTheBlankResultBlankProps = {
  segment: Extract<FillInTheBlankCorrectionSegment, { type: 'blank' }>;
};

const blankClasses: Record<FillInTheBlankCorrectionStatus, string> = {
  correct: 'bg-success-content border-success text-success',
  incorrect: 'bg-error-content border-error text-error',
  empty: 'bg-base-300 border-base-content text-base-content',
};

export function FillInTheBlankResultBlank({
  segment,
}: FillInTheBlankResultBlankProps) {
  const { option, status } = segment;

  return (
    <span
      className={twMerge(
        'mx-1 my-2 inline-flex min-h-12 items-center justify-center rounded-sm border px-5 align-middle font-poppins font-600',
        blankClasses[status],
      )}
    >
      {option && <AnswerContent answer={option} />}
    </span>
  );
}
